import { menu } from './armazon.js';
import { MARCA } from './componentes.js';
import { S } from './estado.js';
import { esc } from './formato.js';
import { ROLES } from '../data/db.js';
import { modalImportar } from '../features/importar-precios.js';
import { modalAnualidades, modalCatalogo, modalCertificacion, modalConfirmarAnular, modalConfirmarBorrarContrato, modalConfirmarBorrarDoc, modalContacto, modalContrato, modalDocumento, modalImputacion, modalMiPassword, modalPedido, modalSimple, modalUnidad, modalUsuario, modalVerPedido } from '../modales/modales.js';
import { vistaAjustes } from '../vistas/ajustes.js';
import { vistaCertificaciones } from '../vistas/certificaciones.js';
import { vistaContratos } from '../vistas/contratos.js';
import { vistaImputaciones } from '../vistas/imputaciones.js';
import { vistaInformes } from '../vistas/informes.js';
import { vistaLogin } from '../vistas/login.js';
import { vistaPanel } from '../vistas/panel.js';
import { vistaPedidos } from '../vistas/pedidos.js';
import { vistaUsuarios } from '../vistas/usuarios.js';

/* =====================================================================
   RENDER
   ===================================================================== */
export function render(){
  const app = document.getElementById('app');
  // Un input tipo fecha (o cualquier campo con id) puede disparar este render
  // mientras el usuario todavía lo tiene con el foco puesto (p.ej. al completar
  // un filtro de fecha). Como el repintado es completo, ese nodo se destruye y
  // el foco cae a <body>, cortando la escritura en seco. Lo recuperamos.
  const foco = document.activeElement;
  const focoId = foco && foco.id && foco!==document.body ? foco.id : null;
  const sel = focoId && 'selectionStart' in foco ? [foco.selectionStart, foco.selectionEnd] : null;
  if(!S.usuario){ app.innerHTML = vistaLogin(); document.getElementById('modal').innerHTML=''; return; }
  const vistas = {panel:vistaPanel, contratos:vistaContratos, imputaciones:vistaImputaciones, pedidos:vistaPedidos,
                  certificaciones:vistaCertificaciones, informes:vistaInformes, usuarios:vistaUsuarios, ajustes:vistaAjustes};
  app.innerHTML = `<div class="app">
    <aside class="rail">
      <div class="rail-head">${MARCA(true,false)}</div>
      <nav class="nav">${menu()}</nav>
      <div class="rail-foot"><div class="copy">© 2026 AGO · David JM</div>
        <div class="u-fila">
          <div><div class="u">${esc(S.usuario.nombre)}</div><div class="r">${esc(ROLES[S.usuario.rol]||S.usuario.rol)}</div></div>
          <button class="btn-llave" data-act="mi-password" title="Cambiar contraseña" aria-label="Cambiar contraseña">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="7.5" cy="15.5" r="4.5"/><path d="m10.6 12.4 8.9-8.9M16 5l3 3M13.5 7.5l2 2"/></svg>
          </button>
        </div>
        <button data-act="salir">Cerrar sesión</button></div>
    </aside>
    <main class="main">${(vistas[S.vista]||vistaPanel)()}</main></div>`;
  if(focoId){
    const el = document.getElementById(focoId);
    if(el){ el.focus(); if(sel && 'setSelectionRange' in el){ try{ el.setSelectionRange(sel[0], sel[1]); }catch{} } }
  }
  const m = S.modal;
  document.getElementById('modal').innerHTML =
    !m ? '' :
    m.t==='imputacion'    ? modalImputacion(m.c) :
    m.t==='contrato'      ? modalContrato(m.id) :
    m.t==='anualidades'   ? modalAnualidades(m.id) :
    m.t==='unidad'        ? modalUnidad(m.c, m.id) :
    m.t==='importar'      ? modalImportar(m.c) :
    m.t==='usuario'       ? modalUsuario(m.id) :
    m.t==='catalogo'      ? modalCatalogo(m.tipo, m.id) :
    m.t==='contacto'      ? modalContacto(m.c, m.id) :
    m.t==='pedido'        ? modalPedido(m.c, m.editId) :
    m.t==='verPedido'     ? modalVerPedido(m.id) :
    m.t==='confirmarAnular' ? modalConfirmarAnular(m.id) :
    m.t==='confirmarBorrarContrato' ? modalConfirmarBorrarContrato(m.id) :
    m.t==='confirmarBorrarDoc' ? modalConfirmarBorrarDoc(m.id, m.pedido) :
    m.t==='certificacion' ? modalCertificacion(m.c) :
    m.t==='documento'     ? modalDocumento(m.c, m.ficheros, m.pedido) :
    m.t==='simple'        ? modalSimple(m.tit, m.msg) :
    m.t==='miPassword'    ? modalMiPassword() : '';
}

